import http from "../../backend/http.js";
import moment from "moment";

async function getIssues(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const queryFilter = `&filter.status=${
      filter.issueStatusFilter.id
    }&filter.projectId=${
      filter.issueProjectFilter ? filter.issueProjectFilter.id : null
    }&filter.implementerId=${
      filter.issueImplementerFilter ? filter.issueImplementerFilter.id : null
    }`;

    const response = await http.get(
      `issues?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${queryFilter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function getIssue(id) {
  try {
    const response = await http.get(`issues/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      description: response.data.description,
      date: moment(response.data.date).format("DD.MM.YY"),
      LogWorks: response.data.logWorks,
      project: response.data.project,
      planDate: response.data.planDate != null && response.data.planDate !== undefined ? response.data.planDate : "",
      status: response.data.status,
      implementer: response.data.implementer,
      creator: response.data.creator,
    };
  } catch (err) {
    throw err;
  }
}

async function createIssue(issue) {
  try {
    const response = await http.post("issues", issue);
    return response;
  } catch (err) {
    throw err;
  }
}

async function updateIssue(id, issue) {
  try {
    await http.put(`issues/${id}`, issue);
  } catch (err) {
    throw err;
  }
}

export { getIssues, getIssue, createIssue, updateIssue };

